import React from 'react';
import PropTypes from 'prop-types';

import theme from 'site-react/theme';
import { css } from 'emotion';

import MaterialIcon from 'site-react/core/Icon/MaterialIcon';

const wrapperStyle = css`
  background-color: ${theme.colors.ghostLogin};
  display: flex;
  justify-content: space-between;
`;

const bannerStyle = css`
  color: ${theme.colors.neutral900};
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${theme.colors.neutral800};
    text-decoration: none;
  }

  &:active {
    color: ${theme.colors.neutral700};
  }
`;

const highlightedTextStyle = css`
  ${theme.contentText3}
  display: flex;
  padding: ${theme.spacing.base * 3}px ${theme.spacing.sm}px
    ${theme.spacing.base * 3}px ${theme.spacing.md}px;
  margin: 0;
`;

const linkStyle = css`
  ${theme.contentText3}
  color: ${theme.colors.neutral900};
  cursor: pointer;
  text-decoration: underline;
  padding: ${theme.spacing.base * 3}px ${theme.spacing.md}px
    ${theme.spacing.base * 3}px ${theme.spacing.sm}px;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

const icon = css`
  font-size: 21px;
  margin-right: ${theme.spacing.sm}px;
  margin-top: -2px;
`;

const GhostLoginBanner = ({ onLogout, user }) => (
  <div className={bannerStyle}>
    <div className={wrapperStyle}>
      <span className={highlightedTextStyle}>
        <MaterialIcon className={icon} iconType="perm_identity" />
        <span>
          You are <strong>ghost logged in</strong> as {user.firstName}{' '}
          {user.lastName} {!!user.company && `(${user.company})`}
        </span>
      </span>
      <button
        onClick={onLogout}
        className={linkStyle}
        data-testid="ghost-login-banner-logout"
        type="button"
      >
        Logout
      </button>
    </div>
  </div>
);

GhostLoginBanner.propTypes = {
  onLogout: PropTypes.func.isRequired,
  /**
   * The user you are logged in as
   */
  user: PropTypes.shape({
    company: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
    phone_country_code: PropTypes.string,
    regional_phone_number: PropTypes.string,
  }).isRequired,
};

export default GhostLoginBanner;
